import React from "react";
import { Form, Input, Button, message } from "antd";
import { Formik, Field } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

const LoginSchema = Yup.object().shape({
  username: Yup.string().required("Required"),
  password: Yup.string().min(6, "Password too short").required("Required"),
});

const Login: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const redirectPath =
    (location.state as { from: { pathname: string } })?.from?.pathname || "/";

  const handleLogin = async (values: {
    username: string;
    password: string;
  }) => {
    try {
      await login(values.username, values.password);
      message.success(t("loginSuccess"));
      navigate(redirectPath, { replace: true });
    } catch (error) {
      message.error(t("loginFailed"));
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6">{t("login")}</h2>
        <Formik
          initialValues={{ username: "user_def", password: "User_def123" }}
          validationSchema={LoginSchema}
          onSubmit={handleLogin}
        >
          {({ handleSubmit, errors, touched }) => (
            <Form layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label={t("username")}
                validateStatus={
                  errors.username && touched.username ? "error" : ""
                }
                help={
                  errors.username && touched.username ? errors.username : null
                }
              >
                <Field
                  name="username"
                  as={Input}
                  placeholder={t("enterUsername")}
                />
              </Form.Item>

              <Form.Item
                label={t("password")}
                validateStatus={
                  errors.password && touched.password ? "error" : ""
                }
                help={
                  errors.password && touched.password ? errors.password : null
                }
              >
                <Field
                  name="password"
                  as={Input.Password}
                  placeholder={t("enterPassword")}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="w-full">
                  {t("login")}
                </Button>
              </Form.Item>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Login;
